import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';


@Component({
    selector: 'app-image-preview',
    templateUrl: './image-preview.component.html',
    styleUrls: ['./image-preview.component.scss'],

})
export class ImagePreviewComponent {
    constructor(
        public dialogRef: MatDialogRef<ImagePreviewComponent>,

        @Inject(MAT_DIALOG_DATA) public data: { imgSrc: string }
    ) { }

    close(): void {
        this.dialogRef.close();
    }
}